
    var riot = require('riot')
    import modalMixin from 'static/script/app/ui/comment-feedback/comment-feedback-modal-mixin';
riot.tag2('comment-feedback-modal-error', '<div class="messaging-modal-body"> <div class="messaging-modal-body-icon"> <span class="warning--before {isError ? \'red\' : \'yellow\'}"></span> </div> <h2 class="messaging-modal-text text-center" show="{header}">{error.header}</h2> <p class="messaging-modal-text text-center">{error.message}</p> <button class="secondary-action messaging-modal-message-action" onclick="{onRetry}" show="{retryButtonVisible}">{error.retryButtonText}</button> <button class="{retryButtonVisible ? \'default-action messaging-modal-message-action\' : \'secondary-action\'}" onclick="{onAbort}">{error.abortButtonText}</button> </div>', '', '', function(opts) {
        this.mixin(modalMixin);

        var errorTypes = {
            VALIDATION: 'ValidationError',
            FATAL: 'Fatal',
            UNABLE_TO_SEND: 'Unable to send message'
        };

        var defaultError = {
            header: null,
            message: 'Ett fel har uppstått.',
            retryButtonVisible: true,
            retryButtonText: 'Ja',
            abortButtonText: 'Nej'
        };

        this.isError = true;
        this.error = defaultError;

        this.getError = function (payload, error) {
            switch (payload.errorType) {
                case errorTypes.VALIDATION:
                    error.message = payload.message;
                    if (payload.errors && payload.errors.length > 0) {
                        error.message = payload.errors.join(' ');
                    };

                    error.retryButtonText = 'Försök igen';
                    error.abortButtonText = 'Avbryt';
                    break;

                case errorTypes.FATAL:
                    error.retryButtonVisible = false;
                    error.abortButtonText = 'Stäng';
                    break;

                case errorTypes.UNABLE_TO_SEND:
                    error.message = payload.message;
                    if (payload.errors && payload.errors.length > 0) {
                        error.message = payload.errors.join(' ');
                    };

                    error.retryButtonVisible = false;
                    error.abortButtonText = 'Stäng';
                    break;
            }

            return error;
        }.bind(this);

        this.onVisible = function () {
            var responseJSON = opts.payload.response.responseJSON;
            this.error = this.getError(responseJSON, defaultError);
        }.bind(this);

        this.onAbort = function () {
            this.bus.trigger('ui:comment-feedback-modal-error:on-close');
        }.bind(this);

        this.onRetry = function () {
            this.bus.trigger('ui:comment-feedback-modal-error:on-retry', this.payload);
        }.bind(this);

        this.on('before-visible', this.onVisible);
});
    
  


// WEBPACK FOOTER //
// ./src/EbaySweden.TouchWeb/static/script/app/ui/comment-feedback/comment-feedback-modal-error.riot.html